/**
 * The export address of a list (FRD-CORE-040): the list's `export` route with the filters and
 * order now applied to the list, without its paging — an export carries every matching row, and
 * the API refuses one above its limit rather than cutting it.
 */
export function exportHref(listPath: string, listQuery?: URLSearchParams): string {
  const query = new URLSearchParams(listQuery);
  query.delete('page');
  query.delete('pageSize');
  const text = query.toString();
  return text === '' ? `${listPath}/export` : `${listPath}/export?${text}`;
}
